import * as yup from 'yup';

export type ChangeEmailData = {
  newEmail: string;
  password: string;
};

export const validationSchema: yup.ObjectSchema<ChangeEmailData> = yup.object({
  newEmail: yup.string().trim().email().required(),
  password: yup.string().required(),
});

export type ChangeEmailFormFields = yup.InferType<typeof validationSchema>;
